/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Edited_OnceInputs */

const en_orders_edited_once = /** @type {(inputs: Orders_Edited_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edited Once`)
};

const es_orders_edited_once = /** @type {(inputs: Orders_Edited_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editado una vez`)
};

/**
* | output |
* | --- |
* | "Edited Once" |
*
* @param {Orders_Edited_OnceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_edited_once = /** @type {((inputs?: Orders_Edited_OnceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Edited_OnceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_edited_once(inputs)
	return es_orders_edited_once(inputs)
});